export default __webpack_public_path__ + "static/media/Logo.smallblurred.a5efc350.png";